module.exports = __webpack_public_path__ + "static/media/settings.fe628d15.svg";